import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import 'draft-js/dist/Draft.css';
import "utils/defaults"

import App from 'App';
import Loading from 'views/Loading';


ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);